import { PayerIds } from '@berry-street/common';
import { AetnaSessionLimitModal } from '@web-app/components/payerActions/AetnaSessionLimitModal';
import { CallPhase, PayerActionRule } from '@web-app/utils/payerActions/types';
import React from 'react';

export const defaultPayerActionRules: PayerActionRule[] = [
  {
    id: 'aetna-session-limit',
    phase: CallPhase.PreCall,
    payerIds: [PayerIds.Aetna],
    actions: [
      {
        id: 'aetna-session-limit-reminder',
        title: 'Aetna Session Limit',
        description: 'Remind provider about Aetna 60-minute session limit',
        renderAction: () => React.createElement(AetnaSessionLimitModal),
      },
    ],
  },
];
